import * as React from 'react';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';

export interface ExplorerEmptyStateProps {
  readonly iconUrl?: string;
  readonly primaryMessage: string;
  readonly secondaryMessage?: string;
  readonly actionButtonMessage?: string;
  readonly onActionButton?: () => void;
  readonly dataTestId?: string;
}

export const ExplorerEmptyState = (props: ExplorerEmptyStateProps): JSX.Element => {
  return (
    <div data-tb-test-id={props.dataTestId} className={NoContentContainer}>
      {props.iconUrl &&
        <img className={NoContentImg} src={props.iconUrl} />
      }
      <div className={Primary}>
        {props.primaryMessage}
      </div>
      {props.secondaryMessage &&
        <div className={Secondary}>
          {props.secondaryMessage}
        </div>
      }
      {props.actionButtonMessage && props.onActionButton &&
        <ButtonWidget buttonType={ButtonType.Outline}
          children={props.actionButtonMessage}
          handleClick={props.onActionButton}
          testId={'empty-state-action'}
          style={{marginTop: 28}}
        />
      }
    </div>
  );
};

const cssPrefix = 'no-content';
const NoContentContainer = cssClass(cssPrefix, 'container', {
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection:'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  left: 0,
  top: 0
});

const NoContentImg = cssClass(cssPrefix, 'img', {
  height: 80,
  width: 80,
  display: 'block',
  margin: '0 auto'
});

const Primary = cssClass(cssPrefix, 'primary', {
  marginTop: 36,
  fontSize: '18px',
  color: CommonStyles.Colors.Grey102
});

const Secondary = cssClass(cssPrefix, 'secondary', {
  marginTop: 16,
  fontSize: '14px',
  color: CommonStyles.Colors.Grey102
});
